import React from "react";

import Button from "sulu-admin-bundle/components/Button";

const headerColums = (props) => {
    const name = props?.t("sulu_admin.match.first.lastname");
    const captain = props?.t("sulu_admin.match.captain");
    const goalkeeper = props?.t("sulu_admin.match.goalkeeper");
    const substitute = props?.t("sulu_admin.match.substitute.gk");

    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1fr 3fr 2fr 1fr 1fr 1fr",
            }}
        >
            <div>Trikot</div>
            <div style={{ textAlign: "center" }}> {name}</div>
            <div style={{ textAlign: "center" }}> Pass-Nr.</div>
            <div style={{ textAlign: "center" }}> {goalkeeper}</div>
            <div style={{ textAlign: "center" }}> {substitute}</div>
            <div style={{ textAlign: "center" }}>{captain}</div>
        </div>
    );

    return hC;
};

const inputNumb = (
    item,
    displayProperty,
    itemClickHandler,
    aditionalParams = ""
) => {
    return <div></div>;
};
const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    aditionalParams = "",
    data,
    openModal,
    index,
    positions,
    isDisabled,
    translate
) => {
    const captain = translate("sulu_admin.match.captain");
    const goalkeeper = translate("sulu_admin.match.goalkeeper");
    const substitute = translate("sulu_admin.match.substitute.gk");

    const excludedProperties = ["firstName", "accountId", "isInCoreSquad"];

    if (excludedProperties.includes(displayProperty)) {
        return null;
    }

    const flagColumns = ["isGoalkeeper", "isSubstituteGoalkeeper", "isCaptain"];

    const fullName =
        displayProperty == "lastName"
            ? item[displayProperty] + ", " + item["firstName"]
            : "";

    const flags = {
        isGoalkeeper: goalkeeper,
        isSubstituteGoalkeeper: substitute,
        isCaptain: captain,
    };

    let flagRender =
        flagColumns.indexOf(displayProperty) >= 0 && item[displayProperty]
            ? flags[displayProperty]
            : "";

    const redCard =
        item["haseRedCard"] && displayProperty === "redCard" ? (
            <div
                style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    background: "#FF0014",
                }}
            ></div>
        ) : (
            ""
        );

    const conditionColumn =
        [...flagColumns, "lastName"].indexOf(displayProperty) === -1;

    const renderContent = () => {
        if (displayProperty === "positions" || displayProperty == "position")
            return;
        if (displayProperty === "passportNumber") {
            return item.passportId ? (
                <div onClick={() => openModal(item)}>
                    <Button skin="link">{item[displayProperty]}</Button>
                </div>
            ) : (
                <div style={{ color: "red" }}>Invalid Pass.</div>
            );
        }
        return conditionColumn && item[displayProperty];
    };

    return (
        <div
            className={itemColumnClass}
            key={displayProperty}
            name={displayProperty}
            style={
                displayProperty === "redCard"
                    ? {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          paddingLeft: "0px",
                      }
                    : displayProperty !== "shirtNumber"
                    ? { textAlign: "center", paddingLeft: "0px" }
                    : { paddingLeft: "10px" }
            }
        >
            {fullName}
            {flagRender}
            {redCard}
            {renderContent()}
        </div>
    );
};
const footer = (noOfSelectedPlayer) => {};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
